module.exports = __webpack_public_path__ + "40574367b0e561b8484203f97e965019.svg";